import Select from 'react-select';
import { useTranslation } from 'react-i18next';

export const CustomSelect = (props) => {
    const { t } = useTranslation();
    const config = props.config || {};
    const className = props.className || '';

    const customSelectStyles = {
        dropdownIndicator: (base) => ({ ...base, color: 'rgb(157, 157, 157)' }),
        control: (base) => ({
            ...base,
            border: '0',
            boxShadow: 'none',
            backgroundColor: '#f9f9f9',
            '&:hover': {
                border: '0',
            },
        }),
        option: (styles, { isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isSelected || isFocused ? '#e0e1e3' : '#f9fafb',
                color: isSelected || isFocused ? '#fff' : '#000',
            };
        },
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 14,
            fontWeight: 500,
            color: '#9a9ab0',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: 14,
            fontWeight: 500,
        }),
        ...config,
    };

    return <Select className={className || 'w-full mt-1'} components={{ IndicatorSeparator: () => null }} styles={customSelectStyles} placeholder={`${t('Select')}...`} {...props} />;
};
